import {
  GetContextMenuItemsParams as AgGridGetContextMenuItemsParams,
  ICellEditorParams as AgGridCellEditorParams,
  ICellRendererParams as AgGridCellRendererParams,
  NewValueParams,
  RowNode as AgGridRowNode,
} from "ag-grid-community";
import { LicenseManager } from "ag-grid-enterprise";

export const useAgGridLicense = () => {
  LicenseManager.setLicenseKey(process.env.REACT_APP_AG_GRID_LICENSE_KEY || "");
};

export type ICellRendererParams<DataType, ContextType = any> = Omit<
  AgGridCellRendererParams,
  "data" | "context"
> & { data?: DataType; context?: ContextType };

export type ICellEditorParams<DataType, ContextType = any> = Omit<
  AgGridCellEditorParams,
  "data" | "context"
> & { data?: DataType; context?: ContextType };

type IRowNode<DataType> = Omit<AgGridRowNode, "data"> & { data?: DataType };

export type IGetContextMenuItemsParams<DataType, ContextType = any> = Omit<
  AgGridGetContextMenuItemsParams,
  "context" | "node"
> & { node: IRowNode<DataType> | null; context: ContextType | null };

export type FixTContext<T extends { context?: any }, ContextType> = Omit<
  T,
  "context"
> & {
  context: ContextType;
};

interface INewValueParams<TData = any, TValue = any>
  extends NewValueParams<TData> {
  /** The value before the change */
  oldValue: TValue;
  /** The value after the change */
  newValue: TValue;
}

export interface IValueSetterParams<TData = any, TValue = any>
  extends INewValueParams<TData, TValue> {}
